import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import KeywordBar from './components/KeywordBar';
import EntryStatus from './components/EntryStatus';
import RankingBoard from './components/RankingBoard';
import NewsGrid from './components/NewsGrid';
import MirrorSection from './components/MirrorSection';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <KeywordBar />
        <EntryStatus />
        <RankingBoard />
        <NewsGrid />
        <MirrorSection />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}